import type { NumberFormatOptions } from './types';

/**
 * Formats a number according to the specified locale and formatting options.
 *
 * @param value - The number to format.
 * @param options - Optional formatting options, including locale, settings, and style.
 * @returns The formatted number as a string.
 *
 * @example
 * ```typescript
 * formatNumber(1234567.89, { locale: 'de-DE', style: 'currency', settings: { currency: 'EUR' } });
 * // "1.234.567,89 €"
 * ```
 */
export const formatNumber = (value: number, options?: NumberFormatOptions): string => {
  const defaults: NumberFormatOptions = {
    locale: 'en-US',
    settings: {},
    style: 'decimal',
  };

  const { locale, settings, style } = {
    ...defaults,
    ...options,
  };

  return new Intl.NumberFormat(locale, {
    ...settings,
    style,
  }).format(value);
};
